import type { WorkshopsCardProps } from "../_model";
import { splitProps } from "solid-js";
import { global } from ":shared/app";

export function WorkshopCard(props: WorkshopsCardProps) {
  const [local, others] = splitProps(props, [
    "link",
    "image",
    "title",
    "category",
    "description",
    "id",
    "instructor",
    "start",
    "end",
    "status",
  ]);
  const category = global.store.actions.flavors.getBadgeStyle({ track: local.category });
  const status = global.store.actions.flavors.getBadgeStyle({ track: local.status });
  const dates = (() => {
    const start = new Date(local.start);
    const end = new Date(local.end);
    return {
      start: {
        day: start.toLocaleString("default", { day: "2-digit" }).toUpperCase(),
        year: start.toLocaleString("default", { year: "numeric" }).toUpperCase(),
        month: start.toLocaleString("default", { month: "short" }).toUpperCase(),
        time: start.toLocaleString("default", { timeStyle: "short" }),
      },
      end: {
        month: end.toLocaleString("default", { month: "short" }).toUpperCase(),
        time: end.toLocaleString("default", { timeStyle: "short" }),
      },
    };
  })();
  return (
    <a
      {...others}
      href={local.link}
      target="_blank"
      class="relative flex flex-col w-full min-h-400px h-400px max-h-400px no-underline rounded-xl bg-bg !overflow-hidden border-1 border-bg-alt border-solid gap-1.5 children:(px2) lt-sm:(min-h-430px h-430px max-h-430px)"
    >
      <div class="flex w-full h-160px !px0">
        <img class="w-full h-full object-cover" src={local.image ?? "/images/placeholders/cover.png"} alt="alt" />
      </div>
      <div class="flex flex-row text-0.4rem gap-2 children:(py-1.5 px-2 rounded-xl items-center text-center bg-badge-bg text-badge-text)">
        <span style={category.style}>{local.category ?? "No category"}</span>
        <span style={status.style}>{local.status ?? "No status"}</span>
      </div>
      <p class="w-full min-h-30px font-bold overflow-hidden whitespace-nowrap truncate <sm:(min-h-40px)">
        {local.title ?? "No Title"}
      </p>
      <p class="flex flex-col w-full text-0.5rem gap-1">
        <span class="before:(content-['By:_'] text-text-alt) w-full overflow-hidden truncate">{local.instructor}</span>
        {/* <span class="w-full text-start text-brand">{`${dates.start.month} ${dates.start.time} - ${dates.end.month} ${dates.end.time}`}</span> */}
        <span class="w-full text-start text-brand">
          {dates.start.day} {dates.start.month} {dates.start.year} ({dates.start.time} {" - "} {dates.end.time})
        </span>
        {/* 14 FEB 2025 (02:22PM - 02:22PM) */}
      </p>

      <p class="flex w-full h-full text-16px overflow-y-auto !overflow-x-hidden scrollbar">
        {local.description ?? "No description"}
      </p>
    </a>
  );
}
